export default (state = {

}, { type, payload }) => {
	switch (type) {
		case 'SET_FORM_SUBMIT_FUNC':
			return {
				...state,
				[payload.id]: payload.value
			}
		default:
			return state
	}
}
